import React from 'react';
import { Link } from 'react-router-dom';

const SingleService = (props) => {
  const {
    itemClass,
    titleClass,
    descClass,
    Title,
    Description,
    btnText,
    btnURL,
    btnClass,
  } = props;
  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'service__item service__border-1  p-relative fix'
      }
    >
      <div className="service__content">
        <h4
          className={titleClass ? titleClass : 'service__title title-color-1'}
        >
          {btnURL ? (
            <Link to={`/${btnURL}`}>
              {Title ? Title : 'Get Latest Updates'}{' '}
            </Link>
          ) : (
            <span>{Title ? Title : 'Get Latest Updates'}</span>
          )}
        </h4>
        <p className={descClass ? descClass : ''}>
          {Description
            ? Description
            : 'Business building it before the tab providet management, Payroll & Worksite Services full-fledged.'}
        </p>
      </div>
      {btnText && (
        <div
          className={btnClass ? btnClass : 'service__link service__link-color-1'}
        >
          {btnURL ? (
            <Link to={`/${btnURL}`}>
              {btnText}
              <i className="fal fa-arrow-right"></i>
            </Link>
          ) : (
            <a 
              href="#" 
              onClick={(e) => e.preventDefault()}
              style={{ cursor: 'pointer' }}
            >
              {btnText}
              <i className="fal fa-arrow-right"></i>
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default SingleService;
